/**
 * BeatShift - Main Entry Point
 *
 * Initializes the game and starts the main loop
 */

import { Game } from './engine/Game';

// Wait for DOM to be ready
window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

  if (!canvas) {
    console.error('Canvas element not found');
    return;
  }

  // Set canvas size
  canvas.width = 800;
  canvas.height = 600;

  // Initialize and start the game
  const game = new Game(canvas);
  game.start();

  console.log('BeatShift initialized successfully');
});
